<template>
  <div class="esp_text_area_view" :style="{backgroundColor: bgColor, padding: padding, textAlign:textAlign}">
    <span v-if="showAll">
      <span v-if="maxLength > 0">
      {{ value }}
      </span>
      <span v-else style="word-wrap:break-word;white-space:pre-wrap;">
      {{ value }}
      </span>
    </span>
    <el-popover v-else width="500" placement="right" :trigger="trigger">
      <span slot="reference" style="cursor: pointer;">
        {{ value.slice(0, maxLength) }}...
      </span>
      <span style="word-wrap:break-word;white-space:pre-wrap;">
        {{ value }}
      </span>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: "EspTextAreaView",
  data() {
    return {}
  },
  props: {
    value: {            // 文本内容
      type: String,
      default: ""
    },
    maxLength: {        // 文本最大显示长度 (没有的话就全部显示)
      type: Number,
      default: 0
    },
    trigger: {          // 触发方式 (click、focus、hover、manual)
      type: String,
      default: "hover"
    },
    bgColor: {          // 背景色
      type: String,
      default: "transparent"
    },
    padding: {          // 内边距
      type: String,
      default: "0px"
    },
    textAlign: {        // 内容对其方式
      type: String,
      default: "left"
    }
  },
  computed: {
    // 计算显示类型
    showAll: function () {
      if (!this.value || this.maxLength <= 0 || this.value.length <= this.maxLength) {
        return true;
      } else {
        return false;
      }
    }
  }
}
</script>

<style lang="less">
.esp_text_area_view {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/common/form/EspTextAreaView.vue